const TEMPLATECONTNET = {
  1: {
    title: "Software Development Services",
    subTitle: 'End-to-End Delivery & Control. Plan. Execute. Deliver.',
    rows: [{
      description: 'Tasks & Subtasks: Organize deliverables into actionable, trackable units. Epics & Sprint Management: Break down large initiatives into agile sprints using Scrum methodology. Scrum & Agile Boards: Plan, assign, and track progress in real-time with Kanban/Scrum views.',
      image: 'SDEFilled'
    },
    {
      description: 'Project Budgets: Set, monitor, and control project costs with budget utilization tracking. Client Billing: Auto-generate invoices linked to task time-tracking and milestone completions.',
      image: 'BudgetsFilled'
    },
    {
      description: 'Bug Tracking: Capture, prioritize, and resolve issues fast with integrated QA boards. Test Case Management: Document, assign, and execute test scenarios across environments. Centralize client requests, SLAs, and technician responses for post-go-live support.',
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Sprints',
      icon: 'ActiveSprintOutlined'
    }, {
      title: 'Modules',
      icon: 'ModulesOutlined'
    }, {
      title: 'Backlog',
      icon: 'BackLogOutlined'
    }, {
      title: 'Components',
      icon: 'ComponentsOutlined'
    }, {
      title: 'Milestone',
      icon: 'MileStoneOutlined'
    }, {
      title: 'Estimation',
      icon: 'EstimationOutlined'
    }, {
      title: 'Test case',
      icon: 'TestCasesOutlined'
    }, {
      title: 'Support Portal',
      icon: 'SupportPortalOutlined'
    }]
  },
  2: {
    title: "Order Management System",
    subTitle: 'From checkout to doorstep — track, fulfill, and resolve every order with ease.',
    rows: [{
      description: 'Order Capture & Confirmation Sync orders from website, mobile app, marketplaces, and POS Auto-confirm and validate inventory in real-time Send instant confirmation to customers with order summary',
      image: 'SDEFilled'
    },
    {
      description: 'Order Capture & Confirmation Sync orders from website, mobile app, marketplaces, and POS Auto-confirm and validate inventory in real-time Send instant confirmation to customers with order summary',
      image: 'BudgetsFilled'
    },
    {
      description: `Returns & Analytics Enable easy return/replacement flows for customers, Monitor order volume, value, status, and cancellations Track SLA breaches and fulfillment times`,
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Orders',
      icon: 'OrdersOutlined'
    }, {
      title: 'Products',
      icon: 'InventoryOutlined'
    }, {
      title: 'Customers',
      icon: 'ClientsOutlined'
    }, {
      title: 'Shipping',
      icon: 'ShippingOutlined'
    }, {
      title: 'Invoice',
      icon: 'PayslipOutlined'
    }, {
      title: 'Reports',
      icon: 'ReportsOutlined'
    }, {
      title: 'Customer Support',
      icon: 'SupportPortalOutlined'
    }]
  },
  3: {
    title: "Sales Prospecting",
    subTitle: 'Streamline Your Sales Prospecting Workflow Turn cold leads into hot deals with automated workflows that drive consistent conversions.',
    rows: [{
      description: `Capture & Qualify Every Lead No more lost prospects.Auto-capture leads from your website, LinkedIn, or cold outreach tools.Enrich leads with company data
Score and segment based on intent, role, and ICP match Assign instantly to the right sales rep`,
      image: 'SDEFilled'
    },
    {
      description: `Convert Leads into Pipeline Revenu Sync lead details into your CRM automatically
Move deals through discovery, proposal, and closure
Collaborate with your team and track next steps in real-time`,
      image: 'BudgetsFilled'
    },
    {
      description: `Run Multi-Touch Outreach Campaigns Launch personalized email, call, and LinkedIn sequences. Track replies, opens, and clicks in one place Get reminders for follow-ups — never miss a touchpoint`,
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Sprints',
      icon: 'ActiveSprintOutlined'
    }, {
      title: 'Modules',
      icon: 'ModulesOutlined'
    }, {
      title: 'Backlog',
      icon: 'BackLogOutlined'
    }, {
      title: 'Components',
      icon: 'ComponentsOutlined'
    }, {
      title: 'Milestone',
      icon: 'MileStoneOutlined'
    }, {
      title: 'Estimation',
      icon: 'EstimationOutlined'
    }, {
      title: 'Test case',
      icon: 'TestCasesOutlined'
    }, {
      title: 'Support Portal',
      icon: 'SupportPortalOutlined'
    }]
  },
  4: {
    title: "Sales Service Management ",
    subTitle: 'Support your sales team with faster responses and seamless deal flow.',
    rows: [{
      description: 'Centralize Sales SupportHandle pricing, legal, and product requests without switching tools. Track everything in one place to reduce back-and-forth.',
      image: 'SDEFilled'
    },
    {
      description: `Accelerate Deal Flow Automate approvals and streamline communication with workflows. Resolve blockers faster and close deals sooner.`,
      image: 'BudgetsFilled'
    },
    {
      description: 'Secure Sensitive Info Limit visibility with role-based access and smart permissions. Ensure every request stays private and compliant.',
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Sprints',
      icon: 'ActiveSprintOutlined'
    }, {
      title: 'Modules',
      icon: 'ModulesOutlined'
    }, {
      title: 'Backlog',
      icon: 'BackLogOutlined'
    }, {
      title: 'Components',
      icon: 'ComponentsOutlined'
    }, {
      title: 'Milestone',
      icon: 'MileStoneOutlined'
    }, {
      title: 'Estimation',
      icon: 'EstimationOutlined'
    }, {
      title: 'Test case',
      icon: 'TestCasesOutlined'
    }, {
      title: 'Support Portal',
      icon: 'SupportPortalOutlined'
    }]
  },
  5: {
    title: "Marketing Project  Management",
    subTitle: `From Idea to Impact – Seamlessly Manage Marketing Projects with Transparency and Speed.
Plan smarter, execute faster, and collaborate better with a structured yet flexible project flow tailored for modern marketing teams.`,
    rows: [{
      description: `Seamless Collaboration Across Teams Bring marketing, design, and leadership onto one platform. No more chasing updates across chats, emails, and docs. Everyone sees what matters — when it matters.`,
      image: 'SDEFilled'
    },
    {
      description: `Clarity from Start to Finish Track every task from brief to launch in one place. Visual boards, timelines, and dashboards keep teams aligned. Never miss a deadline or dependency again.`,
      image: 'BudgetsFilled'
    },
    {
      description: `Accelerated Feedback & Approval Cycles Automated workflows cut review time in half. Route assets, get approvals, and close loops faster. Campaigns move from draft to done without bottlenecks.`,
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Sprints',
      icon: 'ActiveSprintOutlined'
    }, {
      title: 'Modules',
      icon: 'ModulesOutlined'
    }, {
      title: 'Backlog',
      icon: 'BackLogOutlined'
    }, {
      title: 'Components',
      icon: 'ComponentsOutlined'
    }, {
      title: 'Milestone',
      icon: 'MileStoneOutlined'
    }, {
      title: 'Estimation',
      icon: 'EstimationOutlined'
    }, {
      title: 'Test case',
      icon: 'TestCasesOutlined'
    }, {
      title: 'Support Portal',
      icon: 'SupportPortalOutlined'
    }]
  },
  6: {
    title: "Campaign Management",
    subTitle: `Run Marketing Campaigns with Precision, Speed, and Full Team Visibility.From strategy to launch, manage every step in one seamless workspace`,
    rows: [{
      description: `Initiate Campaigns with Clarity Use structured forms to capture goals, budgets, and timelines. Ensure every campaign starts with alignment and purpose. No more vague briefs or scattered details.`,
      image: 'SDEFilled'
    },
    {
      description: `Manage Campaigns with Total Control Track progress, assign owners, and sync across teams. Automations streamline reviews and handoffs. Every asset, task, and update — in one place.`,
      image: 'BudgetsFilled'
    },
    {
      description: `Monitor with Custom Dashboards Visualize KPIs, timelines, and workload in real time. Quickly spot bottlenecks and reallocate resources. Campaign health is always one click away.`,
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Sprints',
      icon: 'ActiveSprintOutlined'
    }, {
      title: 'Modules',
      icon: 'ModulesOutlined'
    }, {
      title: 'Backlog',
      icon: 'BackLogOutlined'
    }, {
      title: 'Components',
      icon: 'ComponentsOutlined'
    }, {
      title: 'Milestone',
      icon: 'MileStoneOutlined'
    }, {
      title: 'Estimation',
      icon: 'EstimationOutlined'
    }, {
      title: 'Test case',
      icon: 'TestCasesOutlined'
    }, {
      title: 'Support Portal',
      icon: 'SupportPortalOutlined'
    }]
  },
  7: {
    title: "Content management",
    subTitle: 'Streamline your content creation process with our efficient content management workflow. From drafting to publishing, ensure smooth collaboration and timely execution.',
    rows: [{
      description: `Draft content collaboratively, get real-time feedback in the review phase, make quick revisions, and schedule posts for seamless publishing`,
      image: 'SDEFilled'
    },
    {
      description: `Improve content quality with structured approval steps. Speed up the review process and ensure consistency with a clear, organized flow`,
      image: 'BudgetsFilled'
    },
    {
      description: `Perfect for marketing, editorial, and project management teams to manage content creation, approvals, and scheduling effectively`,
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Sprints',
      icon: 'ActiveSprintOutlined'
    }, {
      title: 'Modules',
      icon: 'ModulesOutlined'
    }, {
      title: 'Backlog',
      icon: 'BackLogOutlined'
    }, {
      title: 'Components',
      icon: 'ComponentsOutlined'
    }, {
      title: 'Milestone',
      icon: 'MileStoneOutlined'
    }, {
      title: 'Estimation',
      icon: 'EstimationOutlined'
    }, {
      title: 'Test case',
      icon: 'TestCasesOutlined'
    }, {
      title: 'Support Portal',
      icon: 'SupportPortalOutlined'
    }]
  },
  8: {
    title: "Email campaign",
    subTitle: `Transform your email marketing with a streamlined workflow that takes your campaign from idea to inbox. Create, design, approve, and send with ease for maximum impact`,
    rows: [{
      description: `Generate campaign ideas, create compelling content, design visually engaging emails, and streamline the approval process. Once approved, easily schedule and send your campaigns.`,
      image: 'SDEFilled'
    },
    {
      description: `Maximize efficiency with a structured workflow. Create content, design, and approve campaigns faster, ensuring timely delivery and effective reach to your audience.`,
      image: 'BudgetsFilled'
    },
    {
      description: `Best suited for marketing teams focused on email outreach, content teams for crafting messages, and design teams to create eye-catching visuals for campaigns.`,
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Sprints',
      icon: 'ActiveSprintOutlined'
    }, {
      title: 'Modules',
      icon: 'ModulesOutlined'
    }, {
      title: 'Backlog',
      icon: 'BackLogOutlined'
    }, {
      title: 'Components',
      icon: 'ComponentsOutlined'
    }, {
      title: 'Milestone',
      icon: 'MileStoneOutlined'
    }, {
      title: 'Estimation',
      icon: 'EstimationOutlined'
    }, {
      title: 'Test case',
      icon: 'TestCasesOutlined'
    }, {
      title: 'Support Portal',
      icon: 'SupportPortalOutlined'
    }]
  },
  9: {
    title: "Event Planning",
    subTitle: 'Streamline Your Event Planning from Concept to Follow-Up." Effortlessly manage budgeting, promotion, and execution for successful events every time',
    rows: [{
      description: `Start with a solid concept that aligns with business goals.Collaborate across teams for a unified vision. Bring your ideas to life with creative precision.`,
      image: 'SDEFilled'
    },
    {
      description: `Track every expense to stay within budget limits. Easily adjust allocations as priorities shift. Ensure maximum ROI without hidden costs.`,
      image: 'BudgetsFilled'
    },
    {
      description: `Reach the right audience with targeted messaging.Automate email campaigns and social media posts.Increase event registrations with seamless promotions.`,
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Sprints',
      icon: 'ActiveSprintOutlined'
    }, {
      title: 'Modules',
      icon: 'ModulesOutlined'
    }, {
      title: 'Backlog',
      icon: 'BackLogOutlined'
    }, {
      title: 'Components',
      icon: 'ComponentsOutlined'
    }, {
      title: 'Milestone',
      icon: 'MileStoneOutlined'
    }, {
      title: 'Estimation',
      icon: 'EstimationOutlined'
    }, {
      title: 'Test case',
      icon: 'TestCasesOutlined'
    }, {
      title: 'Support Portal',
      icon: 'SupportPortalOutlined'
    }]
  },
  10: {
    title: "Sales pipeline",
    subTitle: 'Track your sales pipeline from lead to close—all in one place. Kwapio helps sales teams stay organized, forecast revenue, and close deals faster.',
    rows: [{
      description: 'Track Every StepManage each lead from first contact to closed deal with built-in workflows.Customize stages to match your sales process and keep momentum moving.',
      image: 'SDEFilled'
    },
    {
      description: 'Visual Pipeline Views Toggle between board, list, calendar, or timeline views based on what you need. Add custom fields like deal value, probability, and expected close date.',
      image: 'BudgetsFilled'
    },
    {
      description: 'Collaborate Easily Bring your team into the loop with shared visibility and instant updates. Use comments, mentions, and task ownership to streamline coordination.',
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Sprints',
      icon: 'ActiveSprintOutlined'
    }, {
      title: 'Modules',
      icon: 'ModulesOutlined'
    }, {
      title: 'Backlog',
      icon: 'BackLogOutlined'
    }, {
      title: 'Components',
      icon: 'ComponentsOutlined'
    }, {
      title: 'Milestone',
      icon: 'MileStoneOutlined'
    }, {
      title: 'Estimation',
      icon: 'EstimationOutlined'
    }, {
      title: 'Test case',
      icon: 'TestCasesOutlined'
    }, {
      title: 'Support Portal',
      icon: 'SupportPortalOutlined'
    }]
  },
  11: {
    title: "Finance service management",
    subTitle: `Streamline Budget Requests, Approvals, and Disbursements with Full Traceability. From submission to closure, manage department and event budgets with CFO-level oversight and control.`,
    rows: [{
      description: `Simplified Budget Requests
Standardized forms reduce errors and back-and-forth. Every request is auto-tagged to its department or event. Easy to track and resubmit if needed.`,
      image: 'SDEFilled'
    },
    {
      description: `Transparent Approval Process
Role-based access keeps finance data secure. Automated reminders reduce approval delays. All actions logged for audit-readiness`,
      image: 'BudgetsFilled'
    },
    {
      description: `Centralized Budget Tracking
Track disbursed vs. allocated budgets in real-time. Dashboards for department-wise and event-wise tracking. Stay informed, avoid overspending, and improve forecasting.`,
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Sprints',
      icon: 'ActiveSprintOutlined'
    }, {
      title: 'Modules',
      icon: 'ModulesOutlined'
    }, {
      title: 'Backlog',
      icon: 'BackLogOutlined'
    }, {
      title: 'Components',
      icon: 'ComponentsOutlined'
    }, {
      title: 'Milestone',
      icon: 'MileStoneOutlined'
    }, {
      title: 'Estimation',
      icon: 'EstimationOutlined'
    }, {
      title: 'Test case',
      icon: 'TestCasesOutlined'
    }, {
      title: 'Support Portal',
      icon: 'SupportPortalOutlined'
    }]
  },
  12: {
    title: "Budget creation",
    subTitle: `Take control of your business finances with a smart, streamlined budget creation process. Collaborate, review, and approve budgets effortlessly—so you can focus on what matters most.`,
    rows: [{
      description: `Speed up decision-making with a structured workflow from draft to publish. No more confusion—just clear steps and real-time status updates.`,
      image: 'SDEFilled'
    },
    {
      description: `Better Collaboration
Enable seamless teamwork with shared access, comments, and notifications. Everyone stays in the loop, reducing miscommunication and delays.`,
      image: 'BudgetsFilled'
    },
    {
      description: `Audit-Ready RecordsTrack every change, comment, and approval in one place. Stay compliant and ready for audits with a complete digital trail.`,
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Sprints',
      icon: 'ActiveSprintOutlined'
    }, {
      title: 'Modules',
      icon: 'ModulesOutlined'
    }, {
      title: 'Backlog',
      icon: 'BackLogOutlined'
    }, {
      title: 'Components',
      icon: 'ComponentsOutlined'
    }, {
      title: 'Milestone',
      icon: 'MileStoneOutlined'
    }, {
      title: 'Estimation',
      icon: 'EstimationOutlined'
    }, {
      title: 'Test case',
      icon: 'TestCasesOutlined'
    }, {
      title: 'Support Portal',
      icon: 'SupportPortalOutlined'
    }]
  },
  13: {
    title: "Project finance management",
    subTitle: `Manage your project finances with precision—from budget planning to final audit.Gain full visibility, track every rupee spent, and make smarter decisions.A single system to control cost, reduce risk, and close projects with confidence.`,
    rows: [{
      description: `Allocate funds based on real needs and priorities. Avoid under- or over-budgeting with clear visibility. Empower teams to plan better from day one.`,
      image: 'SDEFilled'
    },
    {
      description: `Monitor spending as it happens across all teams. Spot anomalies early and stay on top of cash flow. No surprises—just financial clarity at every step.`,
      image: 'BudgetsFilled'
    },
    {
      description: `Generate clear, professional reports in one click.Ensure compliance with audit-ready financial trails.Save time and reduce stress during reviews or audits.`,
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Sprints',
      icon: 'ActiveSprintOutlined'
    }, {
      title: 'Modules',
      icon: 'ModulesOutlined'
    }, {
      title: 'Backlog',
      icon: 'BackLogOutlined'
    }, {
      title: 'Components',
      icon: 'ComponentsOutlined'
    }, {
      title: 'Milestone',
      icon: 'MileStoneOutlined'
    }, {
      title: 'Estimation',
      icon: 'EstimationOutlined'
    }, {
      title: 'Test case',
      icon: 'TestCasesOutlined'
    }, {
      title: 'Support Portal',
      icon: 'SupportPortalOutlined'
    }]
  },
  14: {
    title: "HR service management",
    subTitle: `Streamline employee support with a clear, trackable HR service flow. From simple queries to complex escalations, manage everything in one place. Boost employee satisfaction with faster, more transparent resolutions.`,
    rows: [{
      description: `Faster Response Times Automated routing ensures the right person sees the request immediately. No delays, no confusion—just quick, effective HR support`,
      image: 'SDEFilled'
    },
    {
      description: `Complete Request Visibility Track every HR request from submission to closure. Employees stay informed, and HR teams stay accountable.`,
      image: 'BudgetsFilled'
    },
    {
      description: `Better Escalation HandlingEscalated cases are flagged and prioritized instantly.Ensure no issue goes unresolved or gets lost in the system`,
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Sprints',
      icon: 'ActiveSprintOutlined'
    }, {
      title: 'Modules',
      icon: 'ModulesOutlined'
    }, {
      title: 'Backlog',
      icon: 'BackLogOutlined'
    }, {
      title: 'Components',
      icon: 'ComponentsOutlined'
    }, {
      title: 'Milestone',
      icon: 'MileStoneOutlined'
    }, {
      title: 'Estimation',
      icon: 'EstimationOutlined'
    }, {
      title: 'Test case',
      icon: 'TestCasesOutlined'
    }, {
      title: 'Support Portal',
      icon: 'SupportPortalOutlined'
    }]
  },
  15: {
    title: "Recruitment",
    subTitle: `Streamline your recruitment process from job creation to hiring, ensuring a smooth and efficient candidate journey.Make faster decisions, improve candidate experience, and fill positions with the right talent.`,
    rows: [{
      description: `Efficient Candidate Screening Quickly sift through applications and shortlist the best candidates. Automate initial stages to save time for more meaningful interviews. Ensure you're focusing on the most qualified talent early on.`,
      image: 'SDEFilled'
    },
    {
      description: `Seamless CommunicationMaintain consistent communication with candidates at each stage. Keep them informed and engaged throughout the process. Minimize delays and ensure a positive candidate experience`,
      image: 'BudgetsFilled'
    },
    {
      description: `Data-Driven Decisions Track recruitment metrics to optimize your hiring strategy. Make informed decisions based on real-time data and insights. Identify bottlenecks and improve your recruitment efficiency over time`,
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Sprints',
      icon: 'ActiveSprintOutlined'
    }, {
      title: 'Modules',
      icon: 'ModulesOutlined'
    }, {
      title: 'Backlog',
      icon: 'BackLogOutlined'
    }, {
      title: 'Components',
      icon: 'ComponentsOutlined'
    }, {
      title: 'Milestone',
      icon: 'MileStoneOutlined'
    }, {
      title: 'Estimation',
      icon: 'EstimationOutlined'
    }, {
      title: 'Test case',
      icon: 'TestCasesOutlined'
    }, {
      title: 'Support Portal',
      icon: 'SupportPortalOutlined'
    }]
  },
  16: {
    title: "Policy management",
    subTitle: `Streamline policy creation, approval, and distribution with a simple, efficient system. Ensure compliance, consistency, and clarity across your organization with every policy update.`,
    rows: [{
      description: `Centralized Policy Repository Store all policies in one secure, easily accessible location. Ensure employees can always find and refer to the latest policy versions. Reduce the risk of outdated or conflicting policies being used.`,
      image: 'SDEFilled'
    },
    {
      description: `Streamlined Approval Workflow Automate the process from draft to approval, ensuring quick turnarounds. Involve the right stakeholders at each stage for effective reviews. Maintain clarity and transparency in decision-making.`,
      image: 'BudgetsFilled'
    },
    {
      description: `Compliance & Tracking Track changes to policies and ensure they are updated to meet regulations. Maintain an audit trail for all policy revisions and approvals. Keep your organization compliant with legal or industry standards effortlessly`,
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Sprints',
      icon: 'ActiveSprintOutlined'
    }, {
      title: 'Modules',
      icon: 'ModulesOutlined'
    }, {
      title: 'Backlog',
      icon: 'BackLogOutlined'
    }, {
      title: 'Components',
      icon: 'ComponentsOutlined'
    }, {
      title: 'Milestone',
      icon: 'MileStoneOutlined'
    }, {
      title: 'Estimation',
      icon: 'EstimationOutlined'
    }, {
      title: 'Test case',
      icon: 'TestCasesOutlined'
    }, {
      title: 'Support Portal',
      icon: 'SupportPortalOutlined'
    }]
  },
  17: {
    title: "Performance Review",
    subTitle: `Simplify and enhance employee evaluations with a streamlined performance review system. Drive growth by offering feedback, setting clear goals, and fostering continuous development.`,
    rows: [{
      description: `Clear Performance Metrics Define measurable goals and KPIs for each employee. Track progress against individual targets for accurate performance assessment. Ensure objective and fair evaluations based on data-driven insights`,
      image: 'SDEFilled'
    },
    {
      description: `Continuous Feedback Loop Facilitate ongoing feedback between managers and employees. Help employees improve by providing actionable, real-time suggestions. Promote a culture of continuous learning and growth within the organization`,
      image: 'BudgetsFilled'
    },
    {
      description: `Goal Setting & Alignment Set clear, achievable goals for each employee aligned with company objectives. Ensure team goals are transparent and everyone is working towards the same targets. Increase motivation by giving employees ownership over their professional development`,
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Sprints',
      icon: 'ActiveSprintOutlined'
    }, {
      title: 'Modules',
      icon: 'ModulesOutlined'
    }, {
      title: 'Backlog',
      icon: 'BackLogOutlined'
    }, {
      title: 'Components',
      icon: 'ComponentsOutlined'
    }, {
      title: 'Milestone',
      icon: 'MileStoneOutlined'
    }, {
      title: 'Estimation',
      icon: 'EstimationOutlined'
    }, {
      title: 'Test case',
      icon: 'TestCasesOutlined'
    }, {
      title: 'Support Portal',
      icon: 'SupportPortalOutlined'
    }]
  },
  18: {
    title: "IT Support",
    subTitle: 'Streamline issue resolution and maintain SLA-compliant support with intelligent ticketing and real-time collaboration tools.',
    rows: [{
      description: `IT Support enables streamlined tracking and resolution of service tickets, bugs, and change requests.
With an intuitive interface, teams can categorize, prioritize, and assign issues efficiently.
The system supports various ticket types including bugs, support requests, and feature enhancements.`,
      image: 'SDEFilled'
    },
    {
      description: `Built-in SLA monitoring ensures timely responses and accountability across all support activities.
Teams can track uptime, automate alerts, and stay compliant with defined service levels.
Real-time dashboards provide visibility into issue trends and performance metrics.`,
      image: 'BudgetsFilled'
    },
    {
      description: `Clients gain transparency through a live portal to view statuses, change logs, and KPIs.
Feedback captured from the portal feeds directly into the improvement cycle.
Billable and non-billable hours are auto-logged, supporting accurate time tracking and reporting.`,
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Sprints',
      icon: 'ActiveSprintOutlined'
    }, {
      title: 'Modules',
      icon: 'ModulesOutlined'
    }, {
      title: 'Backlog',
      icon: 'BackLogOutlined'
    }, {
      title: 'Components',
      icon: 'ComponentsOutlined'
    }, {
      title: 'Milestone',
      icon: 'MileStoneOutlined'
    }, {
      title: 'Estimation',
      icon: 'EstimationOutlined'
    }, {
      title: 'Test case',
      icon: 'TestCasesOutlined'
    }, {
      title: 'Support Portal',
      icon: 'SupportPortalOutlined'
    }]
  },
  19: {
    title: "Customer Support",
    subTitle: 'Deliver fast, reliable support to every shopper. Centralize support tickets, streamline resolutions, and keep your customers coming back — with real-time visibility and workflow automation.',
    rows: [{
      description: `Faster Resolutions
Auto-routing and clear ticket stages help agents act quickly. No more delays — resolve issues in hours, not days.`,
      image: 'SDEFilled'
    },
    {
      description: `Improved Accuracy
Each request is tagged, prioritized, and handled by the right team. Fewer mistakes, faster decisions, and happier customers.`,
      image: 'BudgetsFilled'
    },
    {
      description: `Full Visibility Track every issue from open to close with real-time status updates. Managers get instant insights to optimize performance and staffing.`,
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Sprints',
      icon: 'ActiveSprintOutlined'
    }, {
      title: 'Modules',
      icon: 'ModulesOutlined'
    }, {
      title: 'Backlog',
      icon: 'BackLogOutlined'
    }, {
      title: 'Components',
      icon: 'ComponentsOutlined'
    }, {
      title: 'Milestone',
      icon: 'MileStoneOutlined'
    }, {
      title: 'Estimation',
      icon: 'EstimationOutlined'
    }, {
      title: 'Test case',
      icon: 'TestCasesOutlined'
    }, {
      title: 'Support Portal',
      icon: 'SupportPortalOutlined'
    }]
  },
  20: {
    title: "Product Development",
    subTitle: 'Track what matters to product teams',
    rows: [{
      description: `Sprint & Epic Velocity Measure story points completed per sprint
Track average cycle time and lead time per feature
Spot bottlenecks across squads, epics, or priorities`,
      image: 'SDEFilled'
    },
    {
      description: 'Understand how team effort is distributed across bugs, features, and tech debt Forecast upcoming sprint capacity based on current velocity Align resource planning with product goals, not just timelines.',
      image: 'BudgetsFilled'
    },
    {
      description: 'Estimate internal cost per feature based on standard team rates. Link delivery effort to product impact (adoption, revenue, retention). Help finance and leadership make better roadmap tradeoffs.',
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Sprints',
      icon: 'ActiveSprintOutlined'
    }, {
      title: 'Modules',
      icon: 'ModulesOutlined'
    }, {
      title: 'Backlog',
      icon: 'BackLogOutlined'
    }, {
      title: 'Components',
      icon: 'ComponentsOutlined'
    }, {
      title: 'Milestone',
      icon: 'MileStoneOutlined'
    }, {
      title: 'Estimation',
      icon: 'EstimationOutlined'
    }, {
      title: 'Test case',
      icon: 'TestCasesOutlined'
    }, {
      title: 'Support Portal',
      icon: 'SupportPortalOutlined'
    }]
  },
  21: {
    title: "Managed Service Provider Project",
    subTitle: 'Maintain. Monitor. Modernize.',
    rows: [{
      description: 'Service Backlogs: Organize enhancement requests, bugs, and recurring tasks in one place. Release Calendar: Plan and communicate patch cycles, version updates, and deployments. Uptime & SLA Tracking: Monitor system health, automate alerts, and stay SLA-compliant.',
      image: 'SDEFilled'
    },
    {
      description: 'Auto-log hours against tasks, tickets, and service categories. Developer and team-level timesheets with approval workflows. Billable vs non-billable hour tagging.',
      image: 'BudgetsFilled'
    },
    {
      description: 'Client Portal :Share status, change logs, and KPIs in real-time. Feedback Loops: Log client requests directly into the service pipeline. Custom Dashboards: Tailor views for each client’s project health, support tickets, and usage.',
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Sprints',
      icon: 'ActiveSprintOutlined'
    }, {
      title: 'Modules',
      icon: 'ModulesOutlined'
    }, {
      title: 'Backlog',
      icon: 'BackLogOutlined'
    }, {
      title: 'Components',
      icon: 'ComponentsOutlined'
    }, {
      title: 'Milestone',
      icon: 'MileStoneOutlined'
    }, {
      title: 'Estimation',
      icon: 'EstimationOutlined'
    }, {
      title: 'Test case',
      icon: 'TestCasesOutlined'
    }, {
      title: 'Support Portal',
      icon: 'SupportPortalOutlined'
    }]
  },
  22: {
    title: "Asset Management",
    subTitle: 'Manage, track, and maintain assets through their full lifecycle.',
    rows: [{
      description: `Asset Management provides a centralized system to catalog, assign, and monitor organizational assets across departments. Whether it's IT equipment, financial tools, or office infrastructure, all assets can be tracked from procurement to disposal with complete visibility.`,
      image: 'SDEFilled'
    },
    {
      description: `The module streamlines asset assignment and return processes, ensuring accountability through user-based allocation, automated status updates, and condition tracking. Maintenance logs, service schedules, and warranty details are easily recorded to prolong asset lifespan and reduce downtime.`,
      image: 'BudgetsFilled'
    },
    {
      description: `With built-in depreciation tracking and disposal workflows, finance and operations teams can stay audit-ready. Integrated reporting ensures compliance, while real-time dashboards offer insights into asset utilization, upcoming renewals, and underused resources.`,
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Sprints',
      icon: 'ActiveSprintOutlined'
    }, {
      title: 'Modules',
      icon: 'ModulesOutlined'
    }, {
      title: 'Backlog',
      icon: 'BackLogOutlined'
    }, {
      title: 'Components',
      icon: 'ComponentsOutlined'
    }, {
      title: 'Milestone',
      icon: 'MileStoneOutlined'
    }, {
      title: 'Estimation',
      icon: 'EstimationOutlined'
    }, {
      title: 'Test case',
      icon: 'TestCasesOutlined'
    }, {
      title: 'Support Portal',
      icon: 'SupportPortalOutlined'
    }]
  },
  23: {
    title: "Managed Service Provider Project",
    subTitle: 'Maintain. Monitor. Modernize.',
    rows: [{
      description: 'Service Backlogs: Organize enhancement requests, bugs, and recurring tasks in one place. Release Calendar: Plan and communicate patch cycles, version updates, and deployments. Uptime & SLA Tracking: Monitor system health, automate alerts, and stay SLA-compliant.',
      image: 'SDEFilled'
    },
    {
      description: 'Auto-log hours against tasks, tickets, and service categories. Developer and team-level timesheets with approval workflows. Billable vs non-billable hour tagging.',
      image: 'BudgetsFilled'
    },
    {
      description: 'Client Portal :Share status, change logs, and KPIs in real-time. Feedback Loops: Log client requests directly into the service pipeline. Custom Dashboards: Tailor views for each client’s project health, support tickets, and usage.',
      image: 'BugTrackingFilled'
    }],
    workflow: true,
    types: true,
    systemFeatures: [{
      title: 'Sprints',
      icon: 'ActiveSprintOutlined'
    }, {
      title: 'Modules',
      icon: 'ModulesOutlined'
    }, {
      title: 'Backlog',
      icon: 'BackLogOutlined'
    }, {
      title: 'Components',
      icon: 'ComponentsOutlined'
    }, {
      title: 'Milestone',
      icon: 'MileStoneOutlined'
    }, {
      title: 'Estimation',
      icon: 'EstimationOutlined'
    }, {
      title: 'Test case',
      icon: 'TestCasesOutlined'
    }, {
      title: 'Support Portal',
      icon: 'SupportPortalOutlined'
    }]
  }
};

export { TEMPLATECONTNET };
